/** Ключи верхнего уровня, которые не являются полями сырого DRF. */
const RESERVED_TOP_LEVEL_KEYS = new Set([
  "errors",
  "detail",
  "message",
  "code",
  "status_code",
]);

/**
 * Тело ошибки API → массив для Notify [{ field_verbose?, message }].
 * Порядок как в docs/component_requirements/backend/api-error-formats.md.
 */
export function buildErrorNotifications(data, fallbackMessage) {
  if (data == null) {
    return [{ message: fallbackMessage }];
  }

  if (typeof data === "string") {
    return [{ message: fallbackMessage }];
  }

  if (Array.isArray(data)) {
    return data.map((item) => ({ message: String(item) }));
  }

  if (Array.isArray(data.errors) && data.errors.length > 0) {
    return data.errors.map((err) => ({
      field_verbose: err.field_verbose,
      message: err.message || err.detail || String(err),
    }));
  }

  if (data.detail != null && data.detail !== "") {
    const parts = Array.isArray(data.detail) ? data.detail : [data.detail];
    return parts.map((item) => ({ message: String(item) }));
  }

  if (data.message != null && data.message !== "") {
    return [{ message: String(data.message) }];
  }

  const drfItems = [];
  Object.entries(data).forEach(([field, value]) => {
    if (RESERVED_TOP_LEVEL_KEYS.has(field)) return;
    const messages = Array.isArray(value) ? value : [value];
    messages.forEach((msg) => {
      if (msg == null) return;
      drfItems.push({
        field_verbose: field === "non_field_errors" ? undefined : field,
        message: typeof msg === "string" ? msg : String(msg),
      });
    });
  });
  if (drfItems.length > 0) {
    return drfItems;
  }

  return [{ message: fallbackMessage }];
}
